var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-page" },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "bg--white border-radius m-t-25 m-b-25 p-30" },
          [
            _c("h1", [_vm._v("Dashboard")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "m-t-20 m-b-20" },
              _vm._l(_vm.views, function (view) {
                return _c(
                  "button",
                  {
                    key: view.name,
                    class: [
                      "tab-button",
                      { active: _vm.currentView === view.name },
                    ],
                    on: {
                      click: function ($event) {
                        _vm.currentView = view.name
                      },
                    },
                  },
                  [_vm._v("\n          " + _vm._s(view.label) + "\n        ")]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(_vm.currentViewComponent, { tag: "component" }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("router-view", { attrs: { name: "childview" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }